import { apiFetch } from './client.js';

export interface SearchHit {
  chunkId: number;
  fileId: string;
  fileName: string;
  classification: string | null;
  chunkIndex: number;
  pageNum: number | null;
  content: string;
  score: number;
}

export interface SearchResponse {
  query: string;
  topK: number;
  rerank: boolean;
  elapsedMs: number;
  hits: SearchHit[];
}

export async function searchProject(
  projectId: string,
  query: string,
  opts: { topK?: number; noRerank?: boolean } = {},
): Promise<SearchResponse> {
  const params = new URLSearchParams({ q: query });
  if (opts.topK) params.set('topK', String(opts.topK));
  if (opts.noRerank) params.set('noRerank', '1');
  return apiFetch<SearchResponse>(
    `/api/v1/projects/${projectId}/search?${params.toString()}`,
  );
}

export async function reindexProject(projectId: string): Promise<{
  projectId: string;
  enqueued: number;
  files: Array<{ id: string; name: string }>;
}> {
  return apiFetch(`/api/v1/admin/reindex/${projectId}`, { method: 'POST' });
}

export async function embeddingsHealth(): Promise<{
  ok: boolean;
  provider?: string;
  model?: string;
  dimensions?: number;
  message?: string;
}> {
  return apiFetch('/api/v1/admin/embeddings/health');
}
